export default "__VITE_ASSET__CnJLR6AI__"